import * as types from '../mutation-types'

// state
export const state = {
  anfrage: []

}

// mutations
export const mutations = {

    // [types.FETCH_NACHRICHTEN_SUCCESS] (state, { nachrichten }) {
    //   state.nachrichten = nachrichten.thread
    //   state.neueposts = nachrichten.count
    // },
    // [types.FETCH_NACHRICHTEN_FAILURE] (state) {
    //   console.log('Fehler beim Suchen')
    // }
}

// actions
export const actions = {

  async sendAnfrage ({ commit }, payload) {
    const isSuccess = false
    axios.post('/api/v1/anfragesenden', payload)
            .then(resp => {
              if (resp.status === 202) {
                this.dispatch('responseMessage', {
                  type: 'success',
                  modal: 'true',
                  title: 'Anfrage abgesendet! ',
                  text: resp.data
                })
                this.isSuccess = true
                return isSuccess
              }
              this.dispatch('responseMessage', {
                type: 'success',
                modal: 'true',
                title: 'Anfrage abgesendet! ',
                text: 'Vielen Dank, wir werden Ihre Anfrage schnellstmöglichst weiterleiten.'
              })
              this.isSuccess = true
            })
            .catch(resp => {
                // console.log(resp)
              this.dispatch('responseMessage', {
                type: 'warning',
                text: 'Konnte Anfrage leider nicht abschicken..'
              })
            })
    return isSuccess
  },
  async sendAnfrageNachLeistung ({ commit }, payload) {
    const isSuccess = false
    axios.post('/api/v1/anfragesendennachleistung', payload)
            .then(resp => {
              if (resp.status === 202) {
                this.dispatch('responseMessage', {
                  type: 'success',
                  modal: 'true',
                  title: 'Anfrage abgesendet! ',
                  text: resp.data
                })
                this.isSuccess = true
                return isSuccess
              }
              this.dispatch('responseMessage', {
                type: 'success',
                modal: 'true',
                title: 'Anfrage abgesendet! ',
                text: 'Vielen Dank, wir werden Ihre Anfrage schnellstmöglichst weiterleiten.'
              })
              this.isSuccess = true
            })
            .catch(resp => {
                // console.log(resp)
              this.dispatch('responseMessage', {
                type: 'warning',
                text: 'Konnte Anfrage leider nicht abschicken..'
              })
            })
    return isSuccess
  }
}

// getters
export const getters = {

  fetchAnfrage: state => {
    return state.anfragen
  }
    // fetchNeueNachrichten: state => {
    //   return state.neueposts
    // },

    // // betriebecalc: (state) => (betriebe) => {
    // //   let resultArray = []

    // // },
    // nachrichtenszahl: state => state.nachrichten.length
}
